import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type
const returnAssetSlice = createSlice({
  name: "returnAssets",

  initialState: { returnAssets: [], returnAssetsLoader: false },
  reducers: {
    setAllReturnAssets: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.returnAssets = payload;
    },
    setAllReturnAssetsLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.returnAssetsLoader = payload;
    },
    resetAllReturnAssets: (state) => {
      state.returnAssets = [];
    },
  },
});

export const {
  setAllReturnAssets,
  resetAllReturnAssets,
  setAllReturnAssetsLoader,
} = returnAssetSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default returnAssetSlice.reducer;
